import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import type { SituationalGroup } from "./HeroBuilds";

type GroupLabel = {
  group: SituationalGroup;
  title: MessageDescriptor;
  // Когда брать предметы группы — одна строка под названием.
  when: MessageDescriptor;
};

// Группы предметов «по ситуации» на странице героя (доска «19д»), в этом порядке: от линии
// к поздней игре. Пустую группу экран не показывает.
export const SITUATIONAL_GROUPS: readonly GroupLabel[] = [
  {
    group: "lane",
    title: msg({ id: "builds.group.lane", message: "Lane and farm" }),
    when: msg({
      id: "builds.group.lane_when",
      message: "If the lane is tough or you want to farm faster",
    }),
  },
  {
    group: "survive",
    title: msg({ id: "builds.group.survive", message: "Survive fights" }),
    when: msg({ id: "builds.group.survive_when", message: "If you die fast" }),
  },
  {
    group: "weaken",
    title: msg({ id: "builds.group.weaken", message: "Weaken enemies" }),
    when: msg({
      id: "builds.group.weaken_when",
      message: "Stop enemies from healing, escaping and fighting",
    }),
  },
  {
    group: "damage",
    title: msg({ id: "builds.group.damage", message: "More damage" }),
    when: msg({ id: "builds.group.damage_when", message: "Once the core is done" }),
  },
  {
    group: "abilities",
    title: msg({ id: "builds.group.abilities", message: "Stronger abilities" }),
    when: msg({
      id: "builds.group.abilities_when",
      message: "Cooldown, duration and range of abilities",
    }),
  },
  {
    group: "mobility",
    title: msg({ id: "builds.group.mobility", message: "Mobility" }),
    when: msg({ id: "builds.group.mobility_when", message: "Catch up, escape, reach fights" }),
  },
  {
    group: "team",
    title: msg({ id: "builds.group.team", message: "Help the team" }),
    when: msg({ id: "builds.group.team_when", message: "Heal and protect allies" }),
  },
];
